// source: src/common/insight/insight.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var src_common_insight_control_metadata_pb = require('../../../src/common/insight/control_metadata_pb.js');
goog.object.extend(proto, src_common_insight_control_metadata_pb);
var src_common_insight_entity_pb = require('../../../src/common/insight/entity_pb.js');
goog.object.extend(proto, src_common_insight_entity_pb);
var src_common_insight_insight_result_pb = require('../../../src/common/insight/insight_result_pb.js');
goog.object.extend(proto, src_common_insight_insight_result_pb);
goog.exportSymbol('proto.loupe.common.insight.Insight', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.insight.Insight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.insight.Insight.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.insight.Insight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.insight.Insight.displayName = 'proto.loupe.common.insight.Insight';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.insight.Insight.repeatedFields_ = [3,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.insight.Insight.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.insight.Insight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.insight.Insight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.insight.Insight.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    category: jspb.Message.getFieldWithDefault(msg, 2, ""),
    controlMetadataList: jspb.Message.toObjectList(msg.getControlMetadataList(),
    src_common_insight_control_metadata_pb.ControlMetadata.toObject, includeInstance),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    entitiesList: jspb.Message.toObjectList(msg.getEntitiesList(),
    src_common_insight_entity_pb.Entity.toObject, includeInstance),
    lastInteractionAt: (f = msg.getLastInteractionAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    level: jspb.Message.getFieldWithDefault(msg, 7, ""),
    modifiedAt: (f = msg.getModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    name: jspb.Message.getFieldWithDefault(msg, 9, ""),
    personId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    result: (f = msg.getResult()) && src_common_insight_insight_result_pb.InsightResult.toObject(includeInstance, f),
    score: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    status: jspb.Message.getFieldWithDefault(msg, 13, ""),
    teamId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    txId: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.insight.Insight}
 */
proto.loupe.common.insight.Insight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.insight.Insight;
  return proto.loupe.common.insight.Insight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.insight.Insight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.insight.Insight}
 */
proto.loupe.common.insight.Insight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 3:
      var value = new src_common_insight_control_metadata_pb.ControlMetadata;
      reader.readMessage(value,src_common_insight_control_metadata_pb.ControlMetadata.deserializeBinaryFromReader);
      msg.addControlMetadata(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = new src_common_insight_entity_pb.Entity;
      reader.readMessage(value,src_common_insight_entity_pb.Entity.deserializeBinaryFromReader);
      msg.addEntities(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastInteractionAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLevel(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPersonId(value);
      break;
    case 11:
      var value = new src_common_insight_insight_result_pb.InsightResult;
      reader.readMessage(value,src_common_insight_insight_result_pb.InsightResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setScore(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamId(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTxId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.insight.Insight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.insight.Insight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.insight.Insight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.insight.Insight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getControlMetadataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      src_common_insight_control_metadata_pb.ControlMetadata.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      src_common_insight_entity_pb.Entity.serializeBinaryToWriter
    );
  }
  f = message.getLastInteractionAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLevel();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getModifiedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPersonId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      src_common_insight_insight_result_pb.InsightResult.serializeBinaryToWriter
    );
  }
  f = message.getScore();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTeamId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTxId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string category = 2;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated ControlMetadata control_metadata = 3;
 * @return {!Array<!proto.loupe.common.insight.ControlMetadata>}
 */
proto.loupe.common.insight.Insight.prototype.getControlMetadataList = function() {
  return /** @type{!Array<!proto.loupe.common.insight.ControlMetadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_insight_control_metadata_pb.ControlMetadata, 3));
};


/**
 * @param {!Array<!proto.loupe.common.insight.ControlMetadata>} value
 * @return {!proto.loupe.common.insight.Insight} returns this
*/
proto.loupe.common.insight.Insight.prototype.setControlMetadataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loupe.common.insight.ControlMetadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.insight.ControlMetadata}
 */
proto.loupe.common.insight.Insight.prototype.addControlMetadata = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loupe.common.insight.ControlMetadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.clearControlMetadataList = function() {
  return this.setControlMetadataList([]);
};


/**
 * optional google.protobuf.Timestamp created_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.insight.Insight.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.insight.Insight} returns this
*/
proto.loupe.common.insight.Insight.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.insight.Insight.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated Entity entities = 5;
 * @return {!Array<!proto.loupe.common.insight.Entity>}
 */
proto.loupe.common.insight.Insight.prototype.getEntitiesList = function() {
  return /** @type{!Array<!proto.loupe.common.insight.Entity>} */ (
    jspb.Message.getRepeatedWrapperField(this, src_common_insight_entity_pb.Entity, 5));
};


/**
 * @param {!Array<!proto.loupe.common.insight.Entity>} value
 * @return {!proto.loupe.common.insight.Insight} returns this
*/
proto.loupe.common.insight.Insight.prototype.setEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.loupe.common.insight.Entity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.insight.Entity}
 */
proto.loupe.common.insight.Insight.prototype.addEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.loupe.common.insight.Entity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.clearEntitiesList = function() {
  return this.setEntitiesList([]);
};


/**
 * optional google.protobuf.Timestamp last_interaction_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.insight.Insight.prototype.getLastInteractionAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.insight.Insight} returns this
*/
proto.loupe.common.insight.Insight.prototype.setLastInteractionAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.clearLastInteractionAt = function() {
  return this.setLastInteractionAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.insight.Insight.prototype.hasLastInteractionAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string level = 7;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getLevel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setLevel = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp modified_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.insight.Insight.prototype.getModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.insight.Insight} returns this
*/
proto.loupe.common.insight.Insight.prototype.setModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.clearModifiedAt = function() {
  return this.setModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.insight.Insight.prototype.hasModifiedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string name = 9;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string person_id = 10;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getPersonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setPersonId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional InsightResult result = 11;
 * @return {?proto.loupe.common.insight.InsightResult}
 */
proto.loupe.common.insight.Insight.prototype.getResult = function() {
  return /** @type{?proto.loupe.common.insight.InsightResult} */ (
    jspb.Message.getWrapperField(this, src_common_insight_insight_result_pb.InsightResult, 11));
};


/**
 * @param {?proto.loupe.common.insight.InsightResult|undefined} value
 * @return {!proto.loupe.common.insight.Insight} returns this
*/
proto.loupe.common.insight.Insight.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.insight.Insight.prototype.hasResult = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional double score = 12;
 * @return {number}
 */
proto.loupe.common.insight.Insight.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string status = 13;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string team_id = 14;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getTeamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string tx_id = 15;
 * @return {string}
 */
proto.loupe.common.insight.Insight.prototype.getTxId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.insight.Insight} returns this
 */
proto.loupe.common.insight.Insight.prototype.setTxId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


goog.object.extend(exports, proto.loupe.common.insight);
